module.exports = __webpack_public_path__ + "img/developer.ab070cbb.png";